document.addEventListener("DOMContentLoaded", () => {
  const lightbox = document.querySelector("[data-lightbox]")
  if (!lightbox) return

  document.addEventListener("click", (event) => {
    const picture = event.target.closest("[data-zoomable] picture")
    if (!picture) return

    const large = picture.cloneNode(true)
    large.querySelectorAll("source").forEach((source) => source.setAttribute("sizes", "100vw"))
    large.querySelector("img").removeAttribute("loading")
    lightbox.querySelector("picture")?.remove()
    lightbox.append(large)
    lightbox.showModal()
  })
  lightbox.addEventListener("click", () => lightbox.close())
})
